import type { Project } from '@atlassian/jira-issue-create-common-types';
import type { GetFilteredOptionsProps } from './types';

export const getFilteredOptions = ({
	recentProjects,
	allProjects,
	filterQuery,
	renderOptionsLimit,
}: GetFilteredOptionsProps): {
	filteredAllProjects: Project[];
	filteredRecentProjects: Project[];
} => {
	const filteredRecentProjects: Project[] = recentProjects.filter(
		(project: Project) =>
			project.label.toLowerCase().includes(filterQuery.toLowerCase()) ||
			project.projectKey.toLowerCase().includes(filterQuery.toLowerCase()),
	);

	const filteredAllProjects: Project[] = allProjects.filter((project: Project, index: number) => {
		// if query string is there, don't limit options by limit
		if (filterQuery) {
			return (
				project.label.toLowerCase().includes(filterQuery.toLowerCase()) ||
				project.projectKey.toLowerCase().includes(filterQuery.toLowerCase())
			);
		}
		return index < renderOptionsLimit;
	});

	return {
		filteredRecentProjects,
		filteredAllProjects,
	};
};
